export const LABOUR_TYPE = 'SVCITEMTYPE_WORK';
